var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.71 47.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 49"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M69.33 21.26C65.59 16.61 52.21 1.5 35.85 1.5S6.11 16.54 2.44 21.19a4.26 4.26 0 0 0 0 5.33c3.74 4.65 17.12 19.76 33.41 19.76s29.74-15 33.41-19.69a4.35 4.35 0 0 0 .07-5.33"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M35.85 37.89a14 14 0 1 0-14-14 14 14 0 0 0 14 14"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.85,
    cy: 23.89,
    r: 8.11,
    fill: "inherit"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.f3a7c8205efcec08b64cdfe80e7cfe3b.svg";
export { ForwardRef as ReactComponent };